/**
 * Addon App - Dropdown UI & Shadow Cart
 */
// Expose as window global
window.AddonApp = (() => {
  const CONFIG = {
    apiBase: window.AddonAppConfig?.apiBase || 'https://3rdpartysites.techwyse.com/PTL/addonsApp',
    storageKey: 'addon_app_shadow_cart',
    strings: {},
    selectors: {
      addToCartForm: 'form[action*="/cart/add"]',
      addToCartBtn: 'button[type="submit"], button.product-form__submit, [name="add"]',
      cartItemsContainer: '.cart-items, .cart__items, #CartItems',
      drawerFooterTotal: '.totals__total-value, .cart-drawer__footer .totals__total-value', // Selector for total
      checkoutBtn: '[name="checkout"], .cart__checkout-button, button[name="checkout"]',
      priceContainer: '.price-item--regular, .product__price' // To update visual price if needed
    }
  };

  const formatMoney = (cents) => {
    const formatted = (cents / 100).toLocaleString('en-US', {
      style: 'currency',
      currency: window.Shopify.currency.active
    });
    return formatted.replace('CA$', 'C$');
  };

  class ShadowCart {
    static getItems() {
      const stored = localStorage.getItem(CONFIG.storageKey);
      return stored ? JSON.parse(stored) : [];
    }

    static addItem(item) {
      // item: { variant_id, quantity, title, price, image, properties, groupId, parentKey }
      const items = this.getItems();
      items.push(item);
      localStorage.setItem(CONFIG.storageKey, JSON.stringify(items));
      window.dispatchEvent(new CustomEvent('addonapp:cart-updated'));
    }

    static removeItem(index) {
      let items = this.getItems();
      items.splice(index, 1); // Remove by index to handle duplicates correctly if multiple
      localStorage.setItem(CONFIG.storageKey, JSON.stringify(items));
      window.dispatchEvent(new CustomEvent('addonapp:cart-updated'));
      // Reload is safest for UI sync
      window.location.reload();
    }

    static clear() {
      localStorage.removeItem(CONFIG.storageKey);
    }
  }

  class AddonInjector {
    static async init() {
      // Initialize Strings from window config
      if (window.AddonAppConfig && window.AddonAppConfig.strings) {
        CONFIG.strings = { ...CONFIG.strings, ...window.AddonAppConfig.strings };
      }
      // Ensure defaults if missing
      CONFIG.strings.pleaseChoose = CONFIG.strings.pleaseChoose || 'Please choose';
      CONFIG.strings.select = CONFIG.strings.select || 'Select';
      CONFIG.strings.moreInfo = CONFIG.strings.moreInfo || 'More Info';
      CONFIG.strings.lessInfo = CONFIG.strings.lessInfo || 'Less Info';
      CONFIG.strings.processing = CONFIG.strings.processing || 'Processing...';
      CONFIG.strings.addOn = CONFIG.strings.addOn || 'Add-on';
      CONFIG.strings.price = CONFIG.strings.price || 'Price: ';
      CONFIG.strings.sku = CONFIG.strings.sku || 'SKU: ';
      CONFIG.strings.free = CONFIG.strings.free || 'Free';
      CONFIG.strings.errorAdding = CONFIG.strings.errorAdding || 'Error adding to cart. Please try again.';
      CONFIG.strings.checkoutError = CONFIG.strings.checkoutError || 'Checkout Error: ';
      CONFIG.strings.checkoutLogicError = CONFIG.strings.checkoutLogicError || 'Checkout Logic Error. Check console.';

      //  console.log('AddonApp: Init started');

      // Early disable Add to Cart for UX
      // Early disable Add to Cart for UX
      const findBtn = () => {
        const form = document.querySelector(CONFIG.selectors.addToCartForm);
        let btn = form ? form.querySelector(CONFIG.selectors.addToCartBtn) : null;

        // Try form attribute
        if (!btn && form && form.id) {
          btn = document.querySelector(`button[form="${form.id}"]`);
        }

        // Fallback global but avoid Checkout buttons
        if (!btn) {
          const candidates = document.querySelectorAll(CONFIG.selectors.addToCartBtn);
          for (const c of candidates) {
            if (c.closest('#CartDrawer') || c.name === 'checkout') continue;
            btn = c;
            break;
          }
        }
        return btn;
      };

      const loadingBtn = findBtn();
      if (loadingBtn) {
        loadingBtn.setAttribute('aria-disabled', 'true');
        loadingBtn.disabled = true; // Use standard HTML disabled property
        loadingBtn.classList.add('addon-loading');
      }

      const reEnableBtn = () => {
        if (loadingBtn) {
          loadingBtn.removeAttribute('aria-disabled');
          loadingBtn.disabled = false;
          loadingBtn.classList.remove('addon-loading');
        }
      };

      if (!window.meta) { //console.log('AddonApp: window.meta missing');
        reEnableBtn();
        return;
      }
      if (!window.meta.product) { //console.log('AddonApp: Not a product page (window.meta.product missing)');
        reEnableBtn();
        return;
      }

      const productId = window.meta.product.id;
      //  console.log('AddonApp: Product ID found:', productId);

      let addons = [];
      try {
        const lang = document.documentElement.lang || 'en';
        const url = `${CONFIG.apiBase}/get_addons.php?id=${productId}&lang=${lang}`;
        //  console.log('AddonApp: Fetching', url);
        addons = await fetch(url).then(r => r.json());
        //  console.log('AddonApp: Response', addons);
      } catch (e) {
        console.error('AddonApp: Failed to fetch addons', e);
        reEnableBtn();
      }

      if (!addons || addons.length === 0) {
        //  console.log('AddonApp: No addons returned from API');
        reEnableBtn();
        return;
      }
      console.log('AddonApp: Addons found, initializing...', addons);

      this.renderAddons(addons);
      this.attachFormHandler();
      // Initial price update
      this.updateTotalPrice();

      // Re-enable button after render
      reEnableBtn();
    }


  /*  static updateProductLabel(pr_title){

       if (!pr_title) return;

        let title_add = '';
      if (this.currentAddons) {
        this.currentAddons.forEach(addon => {
          const select = addon.domSelect;
          // Check for multi or single
          const selectedOpts = Array.from(select.selectedOptions).filter(o => o.value);
          selectedOpts.forEach(opt => {
        
            title_add = pr_title + "- " + opt.dataset.title;
          });
        });
      }
      document.querySelector(".product__title h1").innerText = title_add;


    }*/

    static updateTotalPrice() {
      const priceEl = document.querySelector(CONFIG.selectors.priceContainer) || document.getElementById('price-container');

     

      if (!priceEl) return;

      // Get Base Price
      // Check data-base-price first (float in dollars? or cents?)
      // Snippet says: product.price | divided_by: 100.0 -> So it's Dollars float.
      let basePrice = parseFloat(priceEl.dataset.basePrice);

      // Fallback if data attribute missing
      if (isNaN(basePrice)) {
        // Try to parse text? "$ 1,200.00" -> 1200.00
        const text = priceEl.innerText.replace(/[^0-9.]/g, '');
        basePrice = parseFloat(text);
      }

      if (isNaN(basePrice)) return;

      // Calculate Addons Total
      let addonTotal = 0;
    
      if (this.currentAddons) {
        this.currentAddons.forEach(addon => {
          const select = addon.domSelect;
          // Check for multi or single
          const selectedOpts = Array.from(select.selectedOptions).filter(o => o.value);
          selectedOpts.forEach(opt => {
            const price = parseFloat(opt.dataset.price || 0);
            addonTotal += price;

          
          });
        });
      }

      const total = basePrice + addonTotal;

   
      // Update UI
      // currency format logic
      // existing formatMoney is cents based?
      // "formatMoney(v.price * 100)" -> input is cents.
      // So passed formatMoney(total * 100)
      priceEl.innerText = formatMoney(total * 100);
      priceEl.innerText = formatMoney(total * 100);
    }

    static toggleSelection(select, val) {
      const opts = Array.from(select.options);
      const opt = opts.find(o => o.value === val);
      if (!opt) return;

      if (select.multiple) {
        opt.selected = !opt.selected;
      } else {
        select.value = val;
      }
      select.dispatchEvent(new Event('change'));
    }

    static updateHeaderSummary(addon, headerText) {
      const select = addon.domSelect;
      const selectedOpts = Array.from(select.selectedOptions).filter(o => o.value);

      if (selectedOpts.length === 0) {
        headerText.innerText = CONFIG.strings.pleaseChoose;
        return;
      }

      const groupTitle = CONFIG.strings.labels?.[addon.title] || addon.title;

      if (addon.multiple_select) {
        // Multi Logic
        let totalAddonPrice = 0;
        selectedOpts.forEach(o => totalAddonPrice += parseFloat(o.dataset.price || 0));

        const priceTxt = totalAddonPrice > 0 ? ` (+${formatMoney(totalAddonPrice * 100)})` : '';
        headerText.innerText = `${selectedOpts.length} ${CONFIG.strings.selected || 'Selected'}${priceTxt}`;
      } else {
        // Single Logic
        const opt = selectedOpts[0];
        const v = { title: opt.dataset.title, price: opt.dataset.price };
        const priceTxt = parseFloat(v.price) > 0 ? ` (+${formatMoney(v.price * 100)})` : '';
        headerText.innerText = `${v.title}${priceTxt}`;
      }
    }

    static renderAddons(addons) {
      const container = document.createElement('div');
      container.className = 'addon-app-options-local'; // Renamed to avoid CSS hiding
      // Use flex column to support 'order' property
      container.style.cssText = 'display: flex; flex-direction: column; margin: 0 0 20px 0px; padding: 0;';

      addons.forEach((addon, index) => {
        const wrapper = document.createElement('div');
        wrapper.className = 'addon-option-wrapper-local';
        wrapper.style.marginBottom = '10px';

        // Apply Order
        if (addon.order !== undefined && addon.order !== null) {
          wrapper.style.order = addon.order;
        } else {
          wrapper.style.order = index + 1;
        }

        const label = document.createElement('label');

        // Helper to decode HTML entities (e.g. &amp; -> &)
        const decodeHtml = (html) => {
          const txt = document.createElement("textarea");
          txt.innerHTML = html;
          return txt.value;
        };

        const cleanTitle = decodeHtml(addon.title);
        let labelText = cleanTitle;

        // Try lookup with clean title
        if (CONFIG.strings.labels && CONFIG.strings.labels[cleanTitle]) {
          labelText = CONFIG.strings.labels[cleanTitle];
        }
       // label.innerHTML = labelText + "<span style='color:red'>*</span>";

       if (!labelText.toLowerCase().includes("extended warranty")) {
      label.innerHTML = labelText + "<span style='color:red'>*</span>";
          }

          else{

            label.innerHTML = labelText;
          }

        label.style.display = 'block';
        label.style.fontWeight = '500';
        label.style.marginBottom = '5px';

        const select = document.createElement('select');
        select.className = 'addon-select';
        select.dataset.addonIndex = index;
        select.style.width = '100%';
        select.style.padding = '8px';
        select.style.border = '1px solid #ccc';
        select.style.borderRadius = '10px';

        // Listen for change
        //select.addEventListener('change', () => this.updateTotalPrice());

            const pr_title = document.querySelector(".product__title h1").innerText;

        select.addEventListener('change', () => {

       

  this.updateTotalPrice();
  //this.updateProductLabel(pr_title);
});

        // Default Option
        const defOpt = document.createElement('option');
        defOpt.value = "";
        defOpt.text = CONFIG.strings.pleaseChoose;
        defOpt.text = CONFIG.strings.pleaseChoose;
        select.appendChild(defOpt);

        if (addon.multiple_select) {
          select.multiple = true;
          // Hide default option for multi
          defOpt.style.display = 'none';
        }

        addon.variants.forEach(v => {
          const opt = document.createElement('option');
          opt.value = v.id;
          opt.dataset.price = v.price;
          opt.dataset.title = v.title;
          opt.dataset.sku = v.sku || '';
          opt.dataset.image = v.image;

          const priceStr = parseFloat(v.price) > 0 ? ` (+${formatMoney(v.price * 100)})` : '';
          opt.text = `${v.title}${priceStr}`;
          select.appendChild(opt);
        });

        wrapper.appendChild(label);
        wrapper.appendChild(select);

        // Always create Accordion UI and hide Select
        if (true) {
          select.style.display = 'none';

          // Main Container
          const accordionContainer = document.createElement('div');
          accordionContainer.className = 'addon-accordion-container';
          // Remove outer border if header handles it, or keep it wrapper style?
          // Using header/list approach:
          accordionContainer.style.position = 'relative';
          accordionContainer.style.marginBottom = '10px';

          // Header (Acts as Dropdown Button)
          const headerBtn = document.createElement('div');
          headerBtn.className = 'addon-accordion-header';
          headerBtn.style.border = '1px solid #0251a8'; // Updated Color
          headerBtn.style.borderRadius = '5px'; // Updated Radius
          headerBtn.style.cursor = 'pointer';
          headerBtn.style.backgroundColor = '#fff';
          headerBtn.style.display = 'flex';
          headerBtn.style.justifyContent = 'space-between';
          headerBtn.style.alignItems = 'stretch';
          headerBtn.style.overflow = 'hidden';

          const headerText = document.createElement('div');
          headerText.style.padding = '7px 15px';
          headerText.style.flex = '1';
          headerText.innerText = CONFIG.strings.pleaseChoose;

          const headerArrow = document.createElement('div');
          headerArrow.style.backgroundColor = '#0251a8'; // User requested blue #0251a8
          headerArrow.style.color = '#fff';
          headerArrow.style.width = '40px';
          headerArrow.style.display = 'flex';
          headerArrow.style.alignItems = 'center';
          headerArrow.style.justifyContent = 'center';
          headerArrow.style.fontSize = '12px';
          headerArrow.innerText = '▼'; // Down Arrow

          headerBtn.appendChild(headerText);
          headerBtn.appendChild(headerArrow);

          // List Container (Hidden by default)
          const listContainer = document.createElement('div');
          listContainer.className = 'addon-accordion-list';
          listContainer.style.display = 'none'; // Collapsed
          listContainer.style.border = '1px solid #0251a8'; // Updated Color
          listContainer.style.borderTop = 'none'; // Merge with header? Or keep separate?
          // If header has radius 10px, adding a list below might look disconnected if list is square top.
          // Let's rely on standard dropdown looks: square top for list?
          // User said "border-radius 10px wherever border is applied".
          listContainer.style.borderRadius = '0 0 10px 10px'; // Bottom round
          // Also remove Header bottom radius when open? Complex.
          // For now, simple standard radius on list.

          listContainer.style.marginTop = '-10px'; // Overlap if needed? 
          // Actually, let's keep it simple: Header is one box, List is another?
          // Usually List attaches to Header.
          // Let's make List separate but visually connected.
          listContainer.style.marginTop = '0'; // Separate slightly?
          listContainer.style.borderRadius = '0 0 5px 5px'; // Full radius for list box if separated

          listContainer.style.maxHeight = '400px';
          listContainer.style.overflowY = 'auto';
          listContainer.style.backgroundColor = '#fff';

          // Toggle logic
          headerBtn.addEventListener('click', () => {
            const isHidden = listContainer.style.display === 'none';
            listContainer.style.display = isHidden ? 'block' : 'none';
            headerArrow.innerText = isHidden ? '▲' : '▼';
          });

          // Populate List
          addon.variants.forEach(v => {
            const card = document.createElement('div');
            card.className = 'addon-card-item';
            card.style.padding = '15px';
            card.style.borderBottom = '1px solid #eee';
            card.style.display = 'flex';
            card.style.flexDirection = 'column';
            card.style.gap = '10px';

            // Row 1: Image + Title + Price
            const topRow = document.createElement('div');
            topRow.style.display = 'flex';
            topRow.style.alignItems = 'center';
            topRow.style.justifyContent = 'space-between'; // Split layout
            topRow.style.gap = '15px';

            // Image if available - ENSURING IT SHOWS
            if (v.image) {
              const img = document.createElement('img');
              img.src = v.image;
              img.style.width = '60px'; // Thumbnail size
              img.style.maxHeight = '100px';
              img.style.objectFit = 'contain';
              img.style.borderRadius = '4px';
              // console.log('AddonApp: Showing image for', v.title, v.image);
              topRow.appendChild(img);
            }

            const titleEl = document.createElement('div');
            titleEl.style.fontWeight = '500';
            titleEl.style.flex = '1'; // Grow to fill space
            titleEl.innerText = v.title;

            const priceEl = document.createElement('div');
            if (parseFloat(v.price) > 0) {
              priceEl.innerText = `+${formatMoney(v.price * 100)}`; // Just price, no 'Add'
              priceEl.style.color = '#0251a8'; // red
              priceEl.style.fontWeight = '500';
              priceEl.style.whiteSpace = 'nowrap'; // Prevent wrapping
            }

            topRow.appendChild(titleEl);
            topRow.appendChild(priceEl);
            card.appendChild(topRow);

            // Row 2: Actions (Select + More Info)
            const actionRow = document.createElement('div');
            actionRow.style.display = 'flex';
            actionRow.style.gap = '10px';
            actionRow.style.marginTop = '5px';

            // Select Button
            const selectBtn = document.createElement('button');
            selectBtn.type = 'button'; // prevent form submit
            selectBtn.innerText = CONFIG.strings.select;
            selectBtn.className = 'btn btn--primary addon-select-btn'; // Use theme button class if likely available
            // selectBtn.style.padding = '6px 15px';
            // selectBtn.style.fontSize = '0.9em';
            // selectBtn.style.backgroundColor = '#0251a8'; // Red-ish from screenshot
            // selectBtn.style.color = '#fff';
            // selectBtn.style.border = 'none';
            // selectBtn.style.borderRadius = '4px';
            // selectBtn.style.cursor = 'pointer';

            selectBtn.addEventListener('click', (e) => {
              e.stopPropagation();
              // Update Select
              AddonInjector.toggleSelection(select, v.id);

              // Update Header
              AddonInjector.updateHeaderSummary(addon, headerText);

              // Close Accordion ONLY if Single Select
              if (!addon.multiple_select) {
                listContainer.style.display = 'none';
                headerArrow.innerText = '▼';
              }

              // Update button states (optional)
              // Reset all Select buttons text? 

              const isSelected = Array.from(select.selectedOptions).some(o => o.value == v.id);

              if (!addon.multiple_select) {
                listContainer.querySelectorAll('.addon-card-item').forEach(c => {
                  c.style.backgroundColor = '#fff';
                  const btn = c.querySelector('.addon-select-btn');
                  if (btn) {
                    btn.innerText = CONFIG.strings.select;
                    btn.style.backgroundColor = ''; // Reset to default class style
                  }
                });
              }

              // Toggle current card style
              if (isSelected) {
                card.style.backgroundColor = '#f0f8ff';
                selectBtn.innerText = CONFIG.strings.selected || 'Selected';
                selectBtn.style.backgroundColor = 'green';
              } else {
                card.style.backgroundColor = '#fff';
                selectBtn.innerText = CONFIG.strings.select;
                selectBtn.style.backgroundColor = '';
              }
            });

            // More Info Button
            const infoBtn = document.createElement('button');
            infoBtn.type = 'button';
            infoBtn.innerHTML = CONFIG.strings.moreInfo; // Down arrow
            infoBtn.className = 'addon-info-btn';
            infoBtn.style.padding = '6px 15px';
            infoBtn.style.fontSize = '0.9em';
            infoBtn.style.backgroundColor = '#fff';
            infoBtn.style.color = '#0251a8';
            infoBtn.style.border = '1px solid #0251a8';
            infoBtn.style.borderRadius = '4px';
            infoBtn.style.cursor = 'pointer';

            // Description Container
            const descDiv = document.createElement('div');
            descDiv.style.display = 'none';
            descDiv.style.marginTop = '10px';
            descDiv.style.fontSize = '0.9em';
            descDiv.style.color = '#555';
            descDiv.style.lineHeight = '1.4';
            if (v.description) {
              descDiv.innerHTML = v.description.replace(/\n/g, '<br>');
            }

            infoBtn.addEventListener('click', (e) => {
              e.stopPropagation();
              const isHidden = descDiv.style.display === 'none';
              descDiv.style.display = isHidden ? 'block' : 'none';
              infoBtn.innerHTML = isHidden ? CONFIG.strings.lessInfo : CONFIG.strings.moreInfo;
            });

            // Assemble
            actionRow.appendChild(selectBtn);
            if (v.description) {
              actionRow.appendChild(infoBtn);
            }
            card.appendChild(actionRow);
            card.appendChild(descDiv);

            listContainer.appendChild(card);
          });

          accordionContainer.appendChild(headerBtn);
          accordionContainer.appendChild(listContainer);
          wrapper.appendChild(accordionContainer);
        }

        container.appendChild(wrapper);

        // Save ref for logic
        addon.domSelect = select;
      });

      // Store loaded addons for handler
      this.currentAddons = addons;

      // Insert into form
      // Try to find the best place. 
      // User Request: Show below matching dropdown (addon-cart) and above variant picker? 
      // Actually: "move product-variant-picker snippets contents to show below our dropdown generated in addon-cart.js"
      // This means: [Addon Dropdown] -> [Variant Picker] -> [Buy Button]
      // So we must inject Addon Dropdown BEFORE Variant Picker.

      const variantPicker = document.querySelector('variant-selects');

      const form = document.querySelector(CONFIG.selectors.addToCartForm);
      let btn = form ? form.querySelector(CONFIG.selectors.addToCartBtn) : null;

      // If not found inside, check for button with form attribute
      if (!btn && form && form.id) {
        btn = document.querySelector(`button[form="${form.id}"]`);
      }

      // Fallback global but avoid Checkout buttons (and ensure it's not a button inside the drawer)
      if (!btn) {
        const candidates = document.querySelectorAll(CONFIG.selectors.addToCartBtn);
        for (const c of candidates) {
          // Check if inside drawer or is checkout
          if (c.closest('#CartDrawer') || c.name === 'checkout') continue;
          btn = c;
          break;
        }
      }

      //  console.log('AddonApp: Injecting widgets...');
      if (variantPicker && variantPicker.parentNode) {
        // console.log('AddonApp: Found Variant Picker, injecting before it.');
        variantPicker.parentNode.insertBefore(container, variantPicker);

        // FIX: Move .pro_variations (Upload/Text) AFTER variantPicker
        const proVariations = document.querySelector('.pro_variations');
        if (proVariations) {
          // console.log('AddonApp: Moving pro_variations after variantPicker');
          // Insert AFTER variantPicker (variantPicker.nextSibling)
          if (variantPicker.nextSibling) {
            variantPicker.parentNode.insertBefore(proVariations, variantPicker.nextSibling);
          } else {
            variantPicker.parentNode.appendChild(proVariations);
          }
        }

      } else if (btn) {
        //  console.log('AddonApp: Found Submit Button, injecting before it.');
        btn.parentNode.insertBefore(container, btn);

        // FIX: Ensure .pro_variations is also moved here if variantPicker wasn't found
        const proVariations = document.querySelector('.pro_variations');
        if (proVariations) {
          // Insert proVariations BEFORE btn, but AFTER container (since container was already inserted before btn)
          // Current DOM: ... container, btn ...
          // insertion: ... container, proVariations, btn ...
          btn.parentNode.insertBefore(proVariations, btn);
        }

      } else if (form) {
        //  console.log('AddonApp: Found Form (no button), appending to end.');
        form.appendChild(container);
      } else {
        console.error('AddonApp: Could not find Add to Cart Form using selector:', CONFIG.selectors.addToCartForm);
      }
    }

    static attachFormHandler() {
      const form = document.querySelector(CONFIG.selectors.addToCartForm);
      if (!form) return;

      // Hijack the submit
      const handleSubmit = async (e) => {
        // Safeguard: If no addons loaded, do not intercept
        if (!this.currentAddons || this.currentAddons.length === 0) return;

        e.preventDefault(); // STOP REDIRECT

        // 1. Generate Unique ID for this Add to Cart event
        const groupId = Date.now().toString();

        // 2. Gather selected addons
        if (this.currentAddons) {
          const selections = [];
          this.currentAddons.forEach(addon => {
            const select = addon.domSelect;
            // Support Multi-Select iterators
            const selectedOpts = Array.from(select.selectedOptions).filter(o => o.value);

            selectedOpts.forEach(opt => {
              // console.log('AddonApp: Selected Option Data', opt.dataset); // DEBUG
              const groupTitle = CONFIG.strings.labels?.[addon.title] || addon.title;
              selections.push({
                variant_id: opt.value, // Use option value
                quantity: 1,
                title: `${groupTitle} - ${opt.dataset.title}`,
                price: opt.dataset.price,
                sku: opt.dataset.sku || '', // Capture SKU
                image: opt.dataset.image || '',
                groupId: groupId, // LINK ADDON TO GROUP
                order: addon.order // Capture Sort Order
              });
            });
          });

          if (selections.length > 0) {
            console.log('AddonApp: Current Selections', selections); // DEBUG
          }
        }

        // 3. Add Base Product (AJAX) with Group ID property
        const formData = new FormData(form);
        const baseId = formData.get('id');
        const quantity = formData.get('quantity') || 1;

        // Collect all properties from the form
        const properties = {};

        // 1. Try FormData first (standard)
        for (const [key, value] of formData.entries()) {
          if (key.startsWith('properties[') && key.endsWith(']')) {
            const propName = key.substring(11, key.length - 1);
            if (value && value.trim() !== '') {
              properties[propName] = value;
            }
          }
        }

        // 2. Manual Scrape for inputs outside the form (rendering issues or ID mismatches)
        // Select all inputs with name starting with "properties["
        const customInputs = document.querySelectorAll('[name^="properties["]');
        customInputs.forEach(input => {
          if (input.disabled) return; // Skip disabled

          const name = input.getAttribute('name');
          // Regex to extract Content between properties[ and ]
          const match = name.match(/^properties\[(.*?)\]$/);
          if (match) {
            const propName = match[1];
            const val = input.value;

            // Handle Checkbox/Radio specifically if needed, but example is Text.
            if (input.type === 'radio' || input.type === 'checkbox') {
              if (!input.checked) return;
            }

            if (val && val.trim() !== '') {
              properties[propName] = val;
            }
          }
        });

        // Add our hidden group ID
        properties['_addon_group_id'] = groupId;

        //  console.log('AddonApp: Adding base product via AJAX:', baseId, 'Group:', groupId);

        const btn = form.querySelector(CONFIG.selectors.addToCartBtn) || document.querySelector(CONFIG.selectors.addToCartBtn);
        if (btn) btn.classList.add('loading');

        try {
          const res = await fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              id: baseId,
              quantity: quantity,
              properties: properties
            })
          });

          if (!res.ok) throw new Error('Failed to add main product');

          const addedItem = await res.json();
          //  console.log('AddonApp: Base Product Added:', addedItem);

          // 3a. Now Add Addons to Shadow Cart linked to the Real Key
          if (this.currentAddons) {
            const selections = [];
            this.currentAddons.forEach(addon => {
              const select = addon.domSelect;
              const selectedOpts = Array.from(select.selectedOptions).filter(o => o.value);

              selectedOpts.forEach(opt => {
                const groupTitle = CONFIG.strings.labels?.[addon.title] || addon.title;
                selections.push({
                  variant_id: opt.value,
                  quantity: 1,
                  title: `${groupTitle} - ${opt.dataset.title}`,
                  price: opt.dataset.price,
                  sku: opt.dataset.sku || '', // Capture SKU
                  image: opt.dataset.image || '',
                  groupId: groupId,
                  parentKey: addedItem.key, // ROBUST LINK
                  order: addon.order // Capture Sort Order
                });
              });
            });

            if (selections.length > 0) {
              selections.forEach(item => ShadowCart.addItem(item));
              //  console.log('AddonApp: Addons added to shadow cart with Group ID:', groupId, 'and Parent Key:', addedItem.key, selections);
            }
          }

          // 3. Update Drawer
          const sectionsRes = await fetch(window.Shopify.routes.root + '?sections=cart-drawer,cart-icon-bubble');
          const sections = await sectionsRes.json();

          const cartDrawer = document.querySelector('cart-drawer');
          if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
            //  console.log('AddonApp: Opening Cart Drawer');
            cartDrawer.renderContents({ sections });
          } else {
            console.warn('AddonApp: Cart Drawer not found, redirecting to cart.');
            window.location.href = window.Shopify.routes.root + 'cart';
          }

        } catch (err) {
          console.error('AddonApp: Error adding to cart', err);
          alert(CONFIG.strings.errorAdding);
        } finally {
          if (btn) btn.classList.remove('loading');
        }
      };

      // Use Capture to run before theme listeners if possible?
      // Or just on 'submit'. theme might preventDefault on 'submit'.
      // If theme uses AJAX, it prevents default.
      // We should listen to 'click' on the button instead?
      // We should listen to 'click' on the button instead?
      let btn = form.querySelector(CONFIG.selectors.addToCartBtn);

      // If not found inside, check for button with form attribute
      if (!btn && form.id) {
        btn = document.querySelector(`button[form="${form.id}"]`);
      }

      // Fallback global but avoid Checkout buttons
      if (!btn) {
        const candidates = document.querySelectorAll(CONFIG.selectors.addToCartBtn);
        for (const c of candidates) {
          if (c.closest('#CartDrawer') || c.name === 'checkout') continue;
          btn = c;
          break;
        }
      }

      if (btn) {
        //  console.log('AddonApp: Attached click handler to button', btn);
        btn.addEventListener('click', (e) => {

          console.log("testing");

          const isValid = validateCustomFields(form);

          console.log(isValid);

          if (!isValid) {
            e.preventDefault();
            e.stopImmediatePropagation();
            return false;
          }



          // We run our logic synchronously-ish (LocalStorage) then let event bubble
          handleSubmit(e);
        });
      } else {
        console.error('AddonApp: attachFormHandler could not find button');
      }
    }
  }

  class CartManager {
    static init() {
      //  console.log('AddonApp: CartManager Init');
      // Logic for Cart Page / Cart Drawer
      // We no longer restrict by path since keys can be anywhere (Drawer)
      this.renderCartInjections();
      this.renderCartInjections();
      this.updateDrawerTotals();
      this.setupObserver();
      this.startPoller();
    }

    static startPoller() {
      // "Nuclear Option" to ensure Total is always correct despite theme overwrites
      setInterval(() => {
        const drawer = document.getElementById('CartDrawer');
        if (drawer && drawer.offsetParent !== null) { // Is Visible
          // console.log('AddonApp: Poller enforcing totals...');
          // efficient check: only if needed? 
          // For now, just run it. The methods are fast.
          this.renderCartInjections();
          this.updateDrawerTotals();
        }
      }, 500);

      // Also listen for detailed cart updates
      document.addEventListener('cart:build', () => {
        //  console.log('AddonApp: cart:build event');
        this.renderCartInjections();
        this.updateDrawerTotals();
      });
      document.addEventListener('cart:refresh', () => {
        //  console.log('AddonApp: cart:refresh event');
        this.renderCartInjections();
        this.updateDrawerTotals();
      });
    }

    static setupObserver() {
      //  console.log('AddonApp: Setting up Observer');
      // Watch for Cart Drawer opening or content changes
      const observer = new MutationObserver((mutations) => {
        let shouldRender = false;
        for (const mutation of mutations) {
          if (mutation.type === 'childList') {
            // Debug log for targets
            // console.log('AddonApp: Mutation Target', mutation.target);
            if (
              (mutation.target.id === 'CartDrawer-CartItems') ||
              (mutation.target.classList && mutation.target.classList.contains('cart-items')) ||
              (mutation.target.closest && mutation.target.closest('#CartDrawer')) // Broader check
            ) {
              //  console.log('AddonApp: Detected Cart Drawer change');
              shouldRender = true;
              break;
            }
          }
        }
        if (shouldRender) {
          // Debounce slightly
          clearTimeout(this._renderTimeout);
          this._renderTimeout = setTimeout(() => {
            this.renderCartInjections();
            this.updateDrawerTotals();
          }, 100);
        }
      });

      observer.observe(document.body, { childList: true, subtree: true });

      // Separate observer for the Total Price element to fight theme overwrites
      const priceObserver = new MutationObserver((mutations) => {
        // Avoid infinite loop: if we just updated it, ignore.
        // We can check if the new text matches what we expect?
        // Or just debounce.
        //  console.log('AddonApp: Price mutation detected');
        clearTimeout(this._priceRenderTimeout);
        this._priceRenderTimeout = setTimeout(() => {
          this.updateDrawerTotals();
        }, 200); // Wait for theme to finish
      });

      const priceEl = document.querySelector(CONFIG.selectors.drawerFooterTotal);
      if (priceEl) {
        priceObserver.observe(priceEl, { childList: true, characterData: true, subtree: true });
        //  console.log('AddonApp: Observing Price Element', priceEl);
      } else {
        // Retry if not found yet (e.g. drawer not in DOM)
        // We can rely on the main observer to attach this later if needed?
        // For now, let's just create a poller or hook into main observer.
        const hookPrice = () => {
          const el = document.querySelector(CONFIG.selectors.drawerFooterTotal);
          if (el) {
            priceObserver.observe(el, { childList: true, characterData: true, subtree: true });
            //  console.log('AddonApp: Price Observer Attached late');
            return true;
          }
          return false;
        };
        if (!hookPrice()) {
          // Try again on document mutations
          const tempObs = new MutationObserver(() => {
            if (hookPrice()) tempObs.disconnect();
          });
          tempObs.observe(document.body, { childList: true, subtree: true });
        }
      }
    }

    static renderCartInjections() {
      const shadowCart = ShadowCart.getItems();
      //  console.log('AddonApp: Rendering Injections. ShadowCart Items:', shadowCart.length);

      // If empty, we should also clean up any potential leftover rows
      if (shadowCart.length === 0) return;

      const itemsContainer = document.querySelector(CONFIG.selectors.cartItemsContainer) || document.querySelector('#CartDrawer-CartItems tbody') || document.querySelector('.cart-items tbody');

      if (!itemsContainer) {
        //  console.log('AddonApp: No Items Container found');
        return;
      }
      //  console.log('AddonApp: Found Container', itemsContainer);

      // Avoid double injection if we already did it and cart hasn't changed?
      // But for Drawer, it rebuilds DOM, so attributes verify.
      if (itemsContainer.dataset.addonInjected === 'true') {
        // Basic check if rows still exist
        if (itemsContainer.querySelectorAll('.addon-shadow-row').length > 0) {
          //  console.log('AddonApp: Rows already exist, skipping.');
          return;
        }
      }

      // Cleanup old rows just in case
      itemsContainer.querySelectorAll('.addon-shadow-row').forEach(row => row.remove());

      // Get all potential parent rows
      // We look for tr elements that might have the data-addon-group-id
      // Since it's inside itemsContainer usually.

      shadowCart.forEach((item, index) => {
        // Find Parent Row by Key (Preferred) or Group ID (Fallback)
        const parentKey = item.parentKey;
        const groupId = item.groupId;
        let parentRow = null;

        if (parentKey) {
          parentRow = itemsContainer.querySelector(`tr[data-key="${parentKey}"]`);
        }

        if (!parentRow && groupId) {
          parentRow = itemsContainer.querySelector(`tr[data-addon-group-id="${groupId}"]`);
        }

        if (!parentRow) {
          // Try parsing key from dataset if format is simple? No.
          //  console.log('AddonApp: Orphan addon (no parent row found):', item.title, parentKey || groupId);
          return;
        }

        //  console.log('AddonApp: Injecting item', item.title, 'under Group', groupId);

        const row = document.createElement('tr');
        row.className = 'cart-item addon-shadow-row';
        row.innerHTML = `
          <td class="cart-item__media">
             <!-- No Image -->
          </td>
          <td class="cart-item__details">
            <span class="cart-item__name break" style="font-size: 0.9em; font-weight: normal;">↳ &nbsp; ${item.title}</span>
          </td>
          <td class="cart-item__totals right">
             <span class="price price--end" style="font-size: 0.9em;">
                 ${parseFloat(item.price) > 0 ? formatMoney(item.price * 100) : CONFIG.strings.free}
             </span>
          </td>
          <td class="cart-item__quantity">
             <!-- Quantity Hidden for Addon -->
          </td>
        `;

        // Insert AFTER the parent row
        // Fix: Use parentRow.parentNode to ensure we insert into the correct container (e.g. tbody)
        // even if itemsContainer selector matched a wrapper div.
        if (parentRow.nextSibling) {
          parentRow.parentNode.insertBefore(row, parentRow.nextSibling);
        } else {
          parentRow.parentNode.appendChild(row);
        }
      });

      itemsContainer.dataset.addonInjected = 'true';
    }

    static updateDrawerTotals() {
      const priceEl = document.querySelector(CONFIG.selectors.drawerFooterTotal);
      if (!priceEl) return;

      //  console.log('AddonApp: Updating Drawer Total');

      // 1. Get current displayed total (Base Products)
      // Remove currency symbols, keep numbers. Note: "CA$1,600.00" or "$1600.00"
      // If we use regex: /[^0-9.]/g might strip decimal points if locale uses comma?
      // "1.600,00"? European.
      // Assuming EN-CA/US for now based on context ($ and .).

      const text = priceEl.innerText;
      let numericText = text.replace(/[^0-9.]/g, '');
      let baseTotal = parseFloat(numericText);

      if (isNaN(baseTotal)) {
        // Fallback attempt: if parsing failed, maybe it's "1,600.00" -> remove comma
        const cleanText = text.replace(/,/g, '').replace(/[^0-9.]/g, '');
        baseTotal = parseFloat(cleanText);
      }

      if (isNaN(baseTotal)) {
        console.warn('AddonApp: Could not parse drawer total:', text);
        return;
      }

      // 2. Add Shadow Items
      const shadowItems = ShadowCart.getItems();
      if (shadowItems.length === 0) return; // No change needed if empty (or should we revert? usually shadow items are the only dynamic part locally)

      // Wait: If we update text, next time we parse it, it includes addons. Double counting!
      // We should check if we already updated it?
      // Or we can verify against real cart total API?
      // Safer: Check if we have a data-original-total attribute.

      if (!priceEl.dataset.originalTotal) {
        priceEl.dataset.originalTotal = baseTotal;
        priceEl.dataset.originalText = text; // cache for currency symbol structure?
      } else {
        baseTotal = parseFloat(priceEl.dataset.originalTotal); // always work from base
      }

      let addonTotal = 0;

      // Filter: Only include addons linked to a visible cart item
      const itemsContainer = document.querySelector(CONFIG.selectors.cartItemsContainer) || document.querySelector('#CartDrawer-CartItems tbody') || document.querySelector('.cart-items tbody');

      if (itemsContainer) {
        shadowItems.forEach(i => {
          let isAttached = false;
          // Check by Key (preferred) or Group ID
          if (i.parentKey && itemsContainer.querySelector(`tr[data-key="${i.parentKey}"]`)) {
            isAttached = true;
          } else if (i.groupId && itemsContainer.querySelector(`tr[data-addon-group-id="${i.groupId}"]`)) {
            isAttached = true;
          }

          if (isAttached) {
            addonTotal += parseFloat(i.price || 0);
          }
        });
      } else {
        // If we can't find the container, we probably shouldn't guess, or just sum all (risky)
        // But usually priceEl and container exist together.
        console.warn('AddonApp: Could not find items container to verify totals.');
      }

      const newTotal = baseTotal + addonTotal;
      //  console.log('AddonApp: New Total', newTotal);

      // 3. Format
      // Re-use formatMoney helper
      priceEl.innerText = formatMoney(newTotal * 100);
    }

    static interceptCheckout() {
      document.addEventListener('click', async (e) => {
        const btn = e.target.closest(CONFIG.selectors.checkoutBtn);
        if (!btn) return;

        const shadowItems = ShadowCart.getItems();
        // Even if shadowItems is empty, we might need to check if we should intercept?
        // But usually standard checkout is fine if no addons.
        // Wait, if we have NO shadow items, we just let standard checkout happen.
        if (shadowItems.length === 0) return;

        e.preventDefault();
        e.stopPropagation();

        const originalText = btn.innerText;
        btn.innerText = CONFIG.strings.processing;
        btn.disabled = true;

        try {
          const realCart = await fetch('/cart.js').then(r => r.json());

          // 1. Group Shadow Items by Parent Key
          const addonsByParent = {};
          shadowItems.forEach(item => {
            if (item.parentKey) {
              if (!addonsByParent[item.parentKey]) addonsByParent[item.parentKey] = [];
              addonsByParent[item.parentKey].push(item);
            }
          });

          // 2. Build Payload with Consolidated Items
          /*const consolidatedItems = realCart.items.map((item, index) => {
            const addons = addonsByParent[item.key] || [];

            if (addons.length === 0) {
              // No addons, pass through as is (no custom price)
              return {
                variant_id: item.variant_id,
                quantity: item.quantity,
                properties: item.properties
              };
            }

            // Calculate Price and Properties
            // 1. Base Product Price
            let totalUnitCost = item.price; // Start with base price (cents)

            // Sort Addons by Order property
            addons.sort((a, b) => {
              const orderA = a.order !== undefined ? parseInt(a.order) : 999;
              const orderB = b.order !== undefined ? parseInt(b.order) : 999;
              return orderA - orderB;
            });

            // 2. Separate Addons: Property-Based vs Separate Line Item (Frontend revert: All become properties)
            // But we need to tag SKU addons specially for Backend Sync

            addons.forEach(addon => {
              const addonPriceDollars = parseFloat(addon.price || 0);
              const addonPriceCents = Math.round(addonPriceDollars * 100);
              totalUnitCost += addonPriceCents;
            });

            // Convert total custom price to string
            const customPrice = (totalUnitCost / 100).toFixed(2);*/









           const consolidatedItems = realCart.items.map((item, index) => {
  const addons = addonsByParent[item.key] || [];

  if (addons.length === 0) {
    return {
      variant_id: item.variant_id,
      quantity: item.quantity,
      properties: item.properties
    };
  }

  // Use Shopify discounted price
  let totalUnitCost = item.final_price || item.price;

  addons.sort((a, b) => {
    const orderA = a.order !== undefined ? parseInt(a.order) : 999;
    const orderB = b.order !== undefined ? parseInt(b.order) : 999;
    return orderA - orderB;
  });

  addons.forEach(addon => {
    const addonPriceDollars = parseFloat(addon.price || 0);
    const addonPriceCents = Math.round(addonPriceDollars * 100);

    totalUnitCost += addonPriceCents;
  });

  const customPrice = (totalUnitCost / 100).toFixed(2);


            // Merge Properties
            const finalProperties = [];

            // Existing properties
            if (item.properties) {
              for (const [k, v] of Object.entries(item.properties)) {
                if (k !== '_addon_group_id') {
                  finalProperties.push({ name: k, value: v });
                }
              }
            }

            // Link Addons as Properties
            addons.forEach(a => {
              // Title: "Category - Option"
              const parts = a.title.split(' - ');
              const name = parts.length >= 2 ? parts[0].trim() : CONFIG.strings.addOn;
              const value = parts.length >= 2 ? parts.slice(1).join(' - ').trim() : a.title;

              const priceLabel = parseFloat(a.price) > 0 ? '$' + a.price : '$0.00';

              if (a.sku && a.sku.trim() !== '') {
                // SKU Addons: Consolidated format
                // Check if SKU matches parent SKU
                const parentSku = item.sku || '';
                const showSku = (a.sku.trim().toLowerCase() !== parentSku.trim().toLowerCase());
                const showPrice = (parseFloat(a.price) > 0);

                let details = [];
                if (showSku) {
                  details.push(`${CONFIG.strings.sku}${a.sku}`);
                }
                if (showPrice) {
                  details.push(`${CONFIG.strings.price}${priceLabel}`);
                }

                let consolidatedValue = value;
                if (details.length > 0) {
                  consolidatedValue += ` (${details.join(' ; ')})`;
                }

                // If no details (Same SKU + Zero Price), it just shows Value
                finalProperties.push({ name: name, value: consolidatedValue });

              } else {
                // Non-SKU Addons: Just show price if > 0 for uniformity
                if (parseFloat(a.price) > 0) {
                  finalProperties.push({ name: name, value: `${value} (+ ${priceLabel})` });
                } else {
                  finalProperties.push({ name: name, value: value });
                }
              }
            });

            // 4. Return Main Item (Single Item)
            return {
              variant_id: item.variant_id,
              quantity: item.quantity,
              custom_price: customPrice,
              properties: finalProperties
            };
          });

          // No flatten needed if we map 1-to-1? 
          // Check: map returns [ {item1}, {item2} ]. 
          // If we return single object, we don't need flat().
          // But to be safe if we change later, flat() handles [obj, obj] just fine? No, flat() handles [[obj], [obj]].
          // If map returns objects directly, flat() might error or do nothing.
          // Let's ensure we return objects and remove flat().

          const flatItems = consolidatedItems; // Renaming for minimal change, or just use consolidatedItems directly.

             const cart = await fetch('/cart.js').then(r => r.json());

          const payload = {
            shopify_cart_items: consolidatedItems,
            addon_items: [],
            currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) ? window.Shopify.currency.active : 'CAD',
            customer: window.Shopify.customer ? { id: window.Shopify.customer.id } : null,

            discounts: {
    codes: cart.discount_codes || [],
    automatic: realCart.items.flatMap(item =>
        (item.discounts || []).map(discount => ({
            title: discount.title,
            amount: discount.amount
        }))
    )
}
          };


       

payload.lead = {
  email: cart.attributes?.["Lead Email"] || "",
  phone: cart.attributes?.["Lead Phone"] || ""
};

          const response = await fetch(`${CONFIG.apiBase}/create_draft_order.php`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload)
          }).then(r => r.json());

          if (response.invoice_url) {
            // Check Version Handshake
            // Version 2.3+ is Variant ID + Price Override (Inventory+Price Fix)
            if (!response.version || response.version < '2.3') {
              console.warn('Server file outdated (v' + (response.version || 'unknown') + ')');
              alert('CRITICAL WARNING: The "create_draft_order.php" file on your server is OUTDATED.\nPlease re-upload the latest file (Inventory+Price Fix).');
            }

            window.location.href = response.invoice_url;
          } else {
            console.error(response);
            alert(CONFIG.strings.checkoutError + (response.message || 'Unknown error'));
            btn.disabled = false;
            btn.innerText = originalText;
          }
        } catch (err) {
          console.error(err);
          alert(CONFIG.strings.checkoutLogicError);
          btn.disabled = false;
          btn.innerText = originalText;
        }
      }, true);
    }
  }

  // Auto Init
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      AddonInjector.init();
      CartManager.init();
      CartManager.interceptCheckout();
    });
  } else {
    AddonInjector.init();
    CartManager.init();
    CartManager.interceptCheckout();
  }

  return { ShadowCart, CartManager, AddonInjector };
})();


function validateCustomFields(form) {
  const requiredFields = [
    '#custom_1',
    '#custom_2',
    '#custom_3',
    '#custom_4',
    '#custom_5',
    '#custom_6',
    '#custom_7'
  ];



  const addonSelects = document.querySelectorAll('select.addon-select');


  let isValid = true;
  let firstInvalidField = null;




  addonSelects.forEach(function (select) {

    const accordion = select.nextElementSibling?.classList.contains('addon-accordion-container')
      ? select.nextElementSibling
      : null;

    // Helper to check validity (Handles Single & Multi)
    const isValidSelection = () => {
      if (select.multiple) {
        // Must have at least one selected option that has a Value (ignore placeholder)
        const selected = Array.from(select.selectedOptions).filter(o => o.value !== "");
        return selected.length > 0;
      }
      return select.value !== "" && select.value.toLowerCase() !== "please choose";
    };


     const label = select.previousElementSibling?.innerText || "";
     if (label.includes("Extended Warranty")) {
       return;
       }


    if (!isValidSelection()) {
      if (accordion) {
        accordion.classList.add('field-error');
      }

      if (!firstInvalidField) {
        firstInvalidField = select;
      }
      isValid = false;
    } else {
      select.style.border = ""; // Reset border if valid
    }

    select.addEventListener('change', () => {
      const addToCartBtn = document.querySelector("button.product-form__submit");

      if (isValidSelection()) {
        if (accordion) accordion.classList.remove('field-error');
        const errorMsg = document.querySelector('.error_msg');
        if (errorMsg) errorMsg.remove();
        if (addToCartBtn) addToCartBtn.removeAttribute('aria-disabled');
      }
    });

  });


  requiredFields.forEach(selector => {
    // Try inside form first, then global
    const field =
      form.querySelector(selector) ||
      document.querySelector(selector);

    if (!field) return;

    field.classList.remove('field-error');




    if (field.value.trim() === '') {
      isValid = false;
      field.classList.add('field-error');

      if (!firstInvalidField) {
        firstInvalidField = field;
      }
    }

    field.addEventListener('input', () => {
      if (field.value.trim() !== '') {
        clearErrorState(field);
      }

    });


  });

  if (!isValid) {

    const target = document.querySelector('.form');
    if (!target) return;

    // Prevent duplicate messages
    if (document.querySelector('.error_msg')) return;

    const errorDiv = document.createElement('div');
    errorDiv.className = 'error_msg';
    errorDiv.textContent = 'Please fill in all required measurement fields.';

    target.parentNode.insertBefore(errorDiv, target);

    firstInvalidField?.focus();

    document.querySelector('.error_msg').scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });

  }

  return isValid;
}


function clearErrorState(field) {

  const addToCartBtn = document.querySelector("button.product-form__submit");

  addToCartBtn.removeAttribute('aria-disabled');

  field.classList.remove('field-error');

  const errorMsg = document.querySelector('.error_msg');
  if (errorMsg) errorMsg.remove();
}